/*
 *******************************************************************************
 *
 *  Filename:   /redux/slices/productgroups.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Product Groups redux reducer
 *
 *  Author:     Norman J. Nolasco [ Archetact Software ]
 *
 *  Created:    Monday, February 12, 2024 - 3:42 AM (CST)
 *
 *  Notes:
 *
 *  Revisions:
 *              2024/02/12  NJN Initial Build
 *
 *  Copyright (c) 2024 - Archetact Software - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  productgroupid: 0,
  error: null,
  defaultToolPanel: "filter",
  order: "NAME ASC",
  search: "",
  columnState: [],
};

const intFields = ["productgroupid"];

const updateFieldReducer = (state, action, field) => {
  const value = action.payload ? action.payload[field] : undefined;

  if (value !== undefined) {
    state[field] = intFields.includes(field) ? parseInt(value, 10) : value;
    state.error = Number.isNaN(state[field]) ? `Invalid value for ${field}.` : null;
  } else {
    state.error = `No ${field} provided.`;
  }
};

export const sessionSlice = createSlice({
  name: "patients",
  initialState,
  reducers: {
    updateProductGroupID: (state, action) => updateFieldReducer(state, action, "productgroupid"),
    updateDefaultToolPanel: (state, action) => updateFieldReducer(state, action, "defaultToolPanel"),
    updateColumnState: (state, action) => updateFieldReducer(state, action, "columnState"),
  },
});

export const { updateProductGroupID, updateDefaultToolPanel, updateColumnState } = sessionSlice.actions;

export default sessionSlice.reducer;
